<h3 *ngIf="course" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
  <div>&nbsp;&nbsp;&nbsp;<strong>Curso:</strong> {{courseService.formatLetra(course.letra)}}</div>
  <div *ngIf="this.showYear">&nbsp;&nbsp;&nbsp;Año: {{course.agno}}</div>
  <div *ngIf="this.showTeacher">&nbsp;&nbsp;&nbsp;Profesor: {{course.teacherName}}</div>
  <div *ngIf="this.showSpeciality">&nbsp;&nbsp;&nbsp;Especialidad: {{course.especialidadNombre}}</div>
</h3>